module.exports = __webpack_public_path__ + "img/buzzer.1e75bca3.jpg";